import React, { type FC, memo, useRef } from "react";
import clsx from "clsx";
import styles from "./HighlightsSlider.module.scss";
import type { GradeFeaturesType } from "../../../../redux/slices/CarConfigGradesSlice";
import HighlightsSliderItem from "./HighlightsSliderItem";
import { useSlider } from "../../../../../../../common-deprecated/features/apheleia/hooks/useSlider";
import HighlightsSliderButtons from "./HighlightsSliderButtons";

type HighlightsSliderProps = {
    gradeFeatures: GradeFeaturesType[];
};

const HighlightsSlider: FC<HighlightsSliderProps> = ({ gradeFeatures }) => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const anyItemRef = useRef<HTMLDivElement | null>(null);

    const { navigate, prevButtonDisabled, nextButtonDisabled, elementProps, isDragging } = useSlider(
        wrapperRef,
        anyItemRef,
        undefined,
        undefined,
        gradeFeatures.length,
    );

    if (gradeFeatures.length === 0) return null;

    return (
        <div className={clsx(styles["highlights-slider"])}>
            <div ref={wrapperRef} {...elementProps} className={clsx(styles.slider, isDragging && styles.dragging)}>
                {gradeFeatures.map((feature, index) => (
                    <HighlightsSliderItem
                        ref={index === 0 ? anyItemRef : undefined}
                        key={feature.id}
                        feature={feature}
                        index={index}
                    />
                ))}

                <HighlightsSliderButtons
                    nextButtonDisabled={nextButtonDisabled}
                    prevButtonDisabled={prevButtonDisabled}
                    navigate={navigate}
                />
            </div>
        </div>
    );
};

export default memo(HighlightsSlider);
